import React from 'react';
import { RegistrationStatusBadge } from '../CustomerSelector/styles';
const ellipsisCell = {
    maxWidth: '220px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};

/** Mesma estrutura visual da listagem PJ: ID, Nome, coluna de contato, Status. */
export const PHYSICAL_PERSON_LIST_COLUMNS = [
    {
        header: 'ID',
        accessor: 'id',
        sortable: false,
        render: (item) => (item?.id != null ? String(item.id) : '—'),
    },
    {
        header: 'Nome',
        accessor: 'name',
        sortable: false,
        render: (item) => (
            <div style={ellipsisCell} title={item?.name || undefined}>
                {item?.name || '—'}
            </div>
        ),
    },
    {
        header: 'Telefone',
        accessor: 'phone',
        sortable: false,
        render: (item) => (
            <div style={{ ...ellipsisCell, maxWidth: '180px' }} title={item?.phone || undefined}>
                {item?.phone || '—'}
            </div>
        ),
    },
    {
        header: 'Status',
        accessor: 'active',
        sortable: false,
        render: (item) => {
            if (item?.active === true) {
                return (
                    <RegistrationStatusBadge $status="ACTIVE" title="Cliente ativo">
                        Ativo
                    </RegistrationStatusBadge>
                );
            }
            if (item?.active === false) {
                return (
                    <RegistrationStatusBadge $status="NULL" title="Cliente inativo">
                        Inativo
                    </RegistrationStatusBadge>
                );
            }
            return '—';
        },
    },
];
